export default (theme) => ({
  primaryColor: theme["--main-color-palette"] || "rgb(2, 31, 66)",
  secondaryColor: theme["--secondary-color-palette"] || "rgb(2, 31, 66)",
  lightWhite: theme["--chat-widget-light-white"] || "#F0F0F0",
  tagsColor: "rgb(50, 172, 65)",
  chatSuggestions:
    theme["--chat-suggestions"] || theme["--secondary-color-palette"],
  chatHeader: theme["--chat-header"] || theme["--secondary-color-palette"],
  chatCta: theme["--chat-cta"] || theme["--main-color-palette"],
  chatWidget: theme["--chat-widget"] || theme["--main-color-palette"],
  chatBackground: theme["--chat-background"] || "#F0F0F0",
  avatarColor: theme["--avatar-color"],
  confirmColor: "#86bb71",
  inactiveColor: "#b4b7b9",
  internalWhite: "#fff",
  internalBlack: "#000",
  textColor: theme["--text-color"] || "#000",
  cardTextColor: "#353535",
  cardTextColorSecondary: "#6E6E6E",
  separatorGray: "#F0F0F0",
  separatorGraySecondary: "#E2E2E2",
});
